import { useCallback } from 'react';

import { userStore } from '@p/security/users/store/store';

import { AddUserForm } from '@t/user/components/add-user/field-values.schema';

export const useAddConfiguration = () => {
  const { addUser, setAddUser } = userStore();
  const handleSubmitted = useCallback((formData: AddUserForm) => {
    formData;
  }, []);

  return { addUser, handleSubmitted, setAddUser };
};
